<template>
  <v-layout>
    <v-menu
        v-model="fromDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
            :label="label"
            prepend-icon="event"
            readonly
            :value="fromDateDisp"
            v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
          locale="en-in"
          :min="minDate"
          :max="maxDate"
          v-model="fromDateVal"
          no-title
          @input="fromDateMenu = false"
      ></v-date-picker>
    </v-menu>
  </v-layout>
</template>
<script>
import moment from "moment";

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      default: function () {
        return moment().format('YYYY-MM-DD');
      }
    },
    label: {
      required: false
    }
  },
  data() {
    return {
      fromDateMenu: false,
      fromDateVal: null,

      minDate: "2019-07-04",
      maxDate: "2099-08-30",
    };
  },
  computed: {
    fromDateDisp() {
      return this.fromDateVal;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function (value) {
        this.fromDateVal = value;
      }
    },
    fromDateVal: function (value) {
      this.$emit('input', value)
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Basic/DateInput.vue